import usePersist from '../../../hooks/usePersist';
import { useSelector } from 'react-redux';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import Loading from '../../ui/Loading';
import { useRefreshTokenAccessMutation } from '../../../features/auth/authApiSlice';
import { selectCurrentAccessToken } from '../../../features/auth/authSlice';
import { useEffect, useState } from 'react';

export default function PersistLogin() {

    const [persist] = usePersist();
    const [refreshTokenAccess, { isLoading: isLoadingRefreshToken }] = useRefreshTokenAccessMutation();
    const staffToken = useSelector(selectCurrentAccessToken);

    const [isRefreshed, setIsRefreshed] = useState<boolean>(false);
    const [refreshFailed, setRefreshFailed] = useState<boolean>(false);
    const navigate = useNavigate();
    const location = useLocation();
    
    useEffect(() => {

        const refresh = async () => {
            if (!staffToken && persist) {
                try {
                    const refreshResult = await refreshTokenAccess().unwrap();
                    if(!refreshResult) {
                        setRefreshFailed(true);
                        return;
                    }
                } catch (err) {
                    setRefreshFailed(true);
                } finally {
                    setIsRefreshed(true);
                }
            } else {
                setIsRefreshed(true);
            }
        };
        
        refresh();
    }, [refreshTokenAccess, persist, staffToken, navigate, location.pathname]);

    if (!persist) return <Outlet />

    if (!isRefreshed || isLoadingRefreshToken) {
        return (
            <div className="flex justify-center items-center min-h-screen">
                <Loading message="Restoring session..." setH={'h-[20px]'} />
            </div>
        )
    }

    return <Outlet />;
}
